import styled from "styled-components";

const Separator = styled.div`
  height: 1px;
  max-height: 1px;
  background-color: #ebebeb;
`;

export default Separator;
